import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, formType, initialEntry) => {
    let newErrors = {};

    if (!newEntry.unitConsumed) {
        newErrors = {
            ...newErrors,
            unitConsumed: { error: true, message: getReqMessage('Unit consumed') }
        };
    }

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (Object.keys(newErrors).length < 1 && formType === 'edit') {
        newErrors = checkDiff(newEntry, initialEntry);
    }

    return newErrors;
};
